import * as yup from "yup"

export const addCategoryValidationSchema = yup.object({
  name: yup.string('Enter your category').required('Category Name is required')
})

export const addCategoryInitialValues = {
  name: "",
  images: null,
}